import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useQuery } from 'urql';
import env from '../../env';
import { accessVersionChoiceSelector } from '../../reducers/videoPage';
import { PlaceHolder, PLACEHOLDER_LAYOUT } from '../../ui-components/PlaceHolder/PlaceHolder';
import { getAbTestVariants, getContentoAbTestVariants } from '../../utils/abiskoUtils';
import { errorStatistics } from '../../utils/statistics/universalStatistics';
import SendStatistics from '../CommonElements/SendStatistics';
import ErrorContainer from '../ErrorHandler/ErrorContainer';
import StartPage from './StartPage';
import StartPageQuery from './StartPage.graphql';

let requestPolicy = 'cache-first';

const StartPageContainer = ({ contentoAbTestVariants, currentAccessibilityChoice }) => {
    const router = { asPath: '/' };

    const [result] = useQuery({
        query: StartPageQuery,
        variables: {
            abTestVariants: contentoAbTestVariants,
            includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
        },
        requestPolicy,
    });

    useEffect(() => {
        return () => {
            requestPolicy = 'cache-and-network';
        };
    }, []);

    const { data, fetching, error } = result;

    if (data) {
        const selections = data.startForSvtPlay.selections;

        const analyticsIdentifiers = data.startForSvtPlay.analyticsIdentifiers;

        return (
            <StartPage
                analyticsIdentifiers={analyticsIdentifiers}
                selections={selections}
                currentAccessibilityChoice={currentAccessibilityChoice}
            />
        );
    }

    if (error) {
        return (
            <>
                <ErrorContainer pathname={router?.asPath} shouldDispatchHttpStatus={true} />
                <SendStatistics statisticsObject={errorStatistics(500, router.asPath)} />
            </>
        );
    }

    if (fetching) {
        return (
            <>
                <PlaceHolder nrOfItems={1} layout={PLACEHOLDER_LAYOUT.HERO} />
                <PlaceHolder nrOfItems={6} layout={PLACEHOLDER_LAYOUT.SHOWCASE} />
            </>
        );
    }

    return null;
};

const mapStateToProps = (state) => {
    return {
        currentAccessibilityChoice: accessVersionChoiceSelector(state),
        contentoAbTestVariants: getContentoAbTestVariants(state),
        abTestVariants: getAbTestVariants(state),
    };
};

export default connect(mapStateToProps)(React.memo(StartPageContainer, () => true));
